<template>
  <section class="featured-gifts">
    <div class="featured-gifts__title-area">
      <span class="featured-gifts__label">{{ data.label }}</span>
      <h2 class="featured-gifts__title">{{ data.title }}</h2>
    </div>

    <div class="featured-gifts__body">
      <div class="featured-gifts__left">
        <div class="featured-gifts__image">
          <img :src="data.mainImage" alt="" />
        </div>
        <h3 class="featured-gifts__lead">{{ data.lead }}</h3>
        <p class="featured-gifts__desc">{{ data.description }}</p>
      </div>

      <div class="featured-gifts__right">
        <FocusCard
          v-for="(card, index) in data.cards"
          :key="index"
          :title="card.title"
          :subtitle="card.description"
          :index="index"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FocusCard from "./FocusCard.vue";

export default {
  name: "FeaturedGifts",
  components: { FocusCard },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.featured-gifts {
  background-color: #eee7d8;
  padding: 56px 40px;
  box-sizing: border-box;

  &__title-area {
    margin-bottom: 28px;
  }

  &__label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #8c6b2f;
    letter-spacing: 1.5px;
    text-align: left;
    display: block;
    margin-bottom: 16px;
  }

  &__title {
    font-family: $font-family;
    font-size: 50px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
  }

  &__body {
    display: flex;
  }

  &__left {
    width: 560px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    margin-right: 24px;
    box-sizing: border-box;
  }

  &__image {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid #d7c39d;
    margin-bottom: 18px;
    height: 591px;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  &__lead {
    font-family: $font-family;
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.04;
    margin: 0 0 18px 0;
    text-align: left;
  }

  &__desc {
    font-family: $font-family;
    font-size: 15px;
    font-weight: normal;
    color: #5f5a54;
    line-height: 1.76;
    margin: 0;
    text-align: left;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;

    .focus-card {
      margin-bottom: 18px;
    }

    .focus-card:last-child {
      margin-bottom: 0;
    }
  }
}

// 平板适配
@media (max-width: 1199px) and (min-width: 768px) {
  .featured-gifts {
    padding: 48px 32px;

    &__left {
      width: 460px;
      margin-right: 20px;
    }

    &__right .focus-card {
      margin-bottom: 16px;
    }
  }
}

// 手机适配
@media (max-width: 767px) {
  .featured-gifts {
    padding: 32px 20px;

    &__title-area {
      margin-bottom: 16px;
    }

    &__label {
      font-size: 11px;
    }

    &__title {
      font-size: 32px;
    }

    &__body {
      flex-direction: column;
    }

    &__left {
      width: 100%;
      margin-right: 0;
      margin-bottom: 14px;
    }

    &__image {
      margin-bottom: 12px;
      height: auto;
    }

    &__lead {
      margin-bottom: 12px;
    }

    &__desc {
      font-size: 14px;
    }

    &__right .focus-card {
      margin-bottom: 12px;
    }
  }
}
</style>
